<template>
  <div v-if="visible" class="fixed inset-0 z-50 flex items-center justify-center">
    <div class="absolute inset-0 bg-black/50 backdrop-blur-[2px]"></div>
    <div class="relative bg-white rounded-xl shadow-2xl w-full max-w-md mx-4 flex flex-col">
      <div class="flex items-center justify-between border-b px-6 py-4">
        <h2 class="text-xl font-bold text-gray-900">Change Password Required</h2>
      </div>
      <div class="px-6 py-4 space-y-4">
        <div class="rounded-md bg-yellow-50 border border-yellow-200 p-3 text-sm text-yellow-800">
          คุณต้องเปลี่ยนรหัสผ่านก่อนใช้งานครั้งแรก / You must change your password before continuing.
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-700">Username</label>
          <input type="text" :value="username" readonly class="mt-1 w-full rounded-md border border-gray-300 bg-gray-50 px-3 py-2 text-sm text-gray-600" />
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-700">Current Password <span class="text-red-500">*</span></label>
          <div class="relative">
            <input v-model="form.currentPassword" :type="showPwd.current ? 'text' : 'password'" autocomplete="current-password" class="mt-1 w-full rounded-md border border-gray-300 px-3 py-2 pr-10 text-sm focus:border-indigo-500 focus:outline-none" />
            <button type="button" tabindex="-1" @click="showPwd.current = !showPwd.current" class="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-400 hover:text-gray-600" :title="showPwd.current ? 'Hide password' : 'Show password'">
              <svg v-if="!showPwd.current" xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"/></svg>
              <svg v-else xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"/></svg>
            </button>
          </div>
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-700">New Password <span class="text-red-500">*</span></label>
          <div class="relative">
            <input v-model="form.newPassword" :type="showPwd.new ? 'text' : 'password'" autocomplete="new-password" class="mt-1 w-full rounded-md border border-gray-300 px-3 py-2 pr-10 text-sm focus:border-indigo-500 focus:outline-none" />
            <button type="button" tabindex="-1" @click="showPwd.new = !showPwd.new" class="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-400 hover:text-gray-600" :title="showPwd.new ? 'Hide password' : 'Show password'">
              <svg v-if="!showPwd.new" xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"/></svg>
              <svg v-else xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"/></svg>
            </button>
          </div>
          <p class="mt-1 text-xs text-gray-500">At least 8 chars, contain letter + digit.</p>
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-700">Confirm New Password <span class="text-red-500">*</span></label>
          <div class="relative">
            <input v-model="form.confirmPassword" :type="showPwd.confirm ? 'text' : 'password'" autocomplete="new-password" class="mt-1 w-full rounded-md border border-gray-300 px-3 py-2 pr-10 text-sm focus:border-indigo-500 focus:outline-none" />
            <button type="button" tabindex="-1" @click="showPwd.confirm = !showPwd.confirm" class="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-400 hover:text-gray-600" :title="showPwd.confirm ? 'Hide password' : 'Show password'">
              <svg v-if="!showPwd.confirm" xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"/></svg>
              <svg v-else xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"/></svg>
            </button>
          </div>
        </div>
        <div v-if="errorMessage" class="rounded-md bg-red-50 border border-red-200 p-3 text-sm text-red-700">
          {{ errorMessage }}
        </div>
      </div>
      <div class="flex justify-end gap-3 border-t px-6 py-4">
        <button
          class="rounded-md bg-indigo-600 px-4 py-2 text-sm font-medium text-white hover:bg-indigo-500 disabled:opacity-60"
          :disabled="isSubmitting"
          @click="submit"
        >
          {{ isSubmitting ? 'Saving...' : 'Change Password' }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from 'sweetalert2'
import * as userService from '@/services/user.service'

export default {
  name: 'ForceChangePasswordModal',
  props: {
    visible: { type: Boolean, default: false },
    username: { type: String, default: '' },
  },
  emits: ['password-changed'],
  data() {
    return {
      form: {
        currentPassword: '',
        newPassword: '',
        confirmPassword: '',
      },
      isSubmitting: false,
      errorMessage: '',
      showPwd: { current: false, new: false, confirm: false },
    }
  },
  methods: {
    validate() {
      const { currentPassword, newPassword, confirmPassword } = this.form
      if (!currentPassword) return 'Current password is required.'
      if (!newPassword) return 'New password is required.'
      if (newPassword.length < 8) return 'New password must be at least 8 characters.'
      if (!/[A-Za-z]/.test(newPassword) || !/[0-9]/.test(newPassword)) {
        return 'New password must contain at least one letter and one digit.'
      }
      if (newPassword === '1234') return 'New password must not be "1234".'
      if (newPassword === currentPassword) return 'New password must differ from current password.'
      if (newPassword !== confirmPassword) return 'New password and confirmation do not match.'
      return ''
    },
    async submit() {
      this.errorMessage = ''
      const err = this.validate()
      if (err) {
        this.errorMessage = err
        return
      }
      this.isSubmitting = true
      try {
        const res = await userService.changePassword({
          currentPassword: this.form.currentPassword,
          newPassword: this.form.newPassword,
        })
        if (res?.status === 'success') {
          this.$store.dispatch('clearMustChangePassword')
          this.form = { currentPassword: '', newPassword: '', confirmPassword: '' }
          await Swal.fire({ icon: 'success', title: 'Password Changed', text: 'Your password has been updated.' })
          this.$emit('password-changed')
        } else {
          this.errorMessage = res?.message || 'Failed to change password.'
        }
      } catch (e) {
        console.error('changePassword error:', e)
        this.errorMessage = 'Failed to change password.'
      } finally {
        this.isSubmitting = false
      }
    },
  },
}
</script>

<style scoped></style>
